<div>
    <div class="mb-3" [hidden]="newFirmwareVisible">
        <div class="mb-3">
            <button class="btn btn-sm btn-primary" (click)="displayNewFirmwareFormGroup()">
                <i class="fas fa-plus-circle"></i> New firmware
            </button>
        </div>
    </div>
    <div class="mb-3 background-hover" [hidden]="!newFirmwareVisible" [formGroup]="newFirmwareFormGroup">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareNameInput">Name</label>
                    <input type="text" class="form-control" id="newFirmwareNameInput" placeholder="Apollo, Freescale, Nordic, Picture, TouchPanel, ..." formControlName="newFirmwareNameInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label>File</label>
                    <div>
                        <input type="file" class="form-control" id="newFirmwareFileInput" (change)="newFirmwareFileInputChange($event)" formControlName="newFirmwareFileInput">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareVersionTXTInput">Version(TXT)</label>
                    <input type="text" class="form-control" id="newFirmwareVersionTXTInput" placeholder="1.0, 2.1, 3.3, V004, ..." formControlName="newFirmwareVersionTXTInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareVersionInput">Version</label>
                    <input type="number" min="0" max="65535" class="form-control" id="newFirmwareVersionInput" formControlName="newFirmwareVersionInput" placeholder="101, 221, 345, ...">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareMinVersionInput">Min. Required (optional)</label>
                    <input type="number" min="0" max="65535" class="form-control" id="newFirmwareMinVersionInput" formControlName="newFirmwareMinVersionInput" placeholder="101, 221, 345, ...">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareMD5Input">Checksum</label>
                    <input type="text" class="form-control" id="newFirmwareMD5Input" placeholder="md5 (4cb1325f176091e7f0005fcc0e558c7d, ...)" formControlName="newFirmwareMD5Input">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="newFirmwareForceSelect">Update</label>
                    <select class="form-select" id="newFirmwareForceSelect" formControlName="newFirmwareForceSelect">
                        <option value="false">optional</option>
                        <option value="true">mandatory</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row gx-1">
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" [disabled]="newFirmwareFormGroup.invalid" (click)="uploadNewFirmware()">
                    <i class="fas fa-cloud-upload-alt"></i> Upload
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-secondary" (click)="hideNewFirmwareFormGroup()">
                    <i class="fas fa-ban"></i> Cancel
                </button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="lastFirmwaresForTestUsers || lastFirmwaresForBetaUsers || lastFirmwaresForEndUsers">
    <h4>Last firmwares</h4>
    <div *ngIf="lastFirmwaresForTestUsers">
        <h5>For admin and test users</h5>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Version(TXT)</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of lastFirmwaresForTestUsers.firmwares">
                    <td scope="row">
                        {{ firmware.name }}
                    </td>
                    <td>
                        {{ firmware.versionTxt }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.fileName">
                            <i class="fas fa-download"></i> {{ firmware.fileName }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishDate : firmware.uploadDate) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'NEW'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'" [class.bg-light]="firmware.status == 'ARCHIVED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>
                        <a [href]="lastFirmwaresForTestUsers.globalUrl" *ngIf="lastFirmwaresForTestUsers.globalUrl">
                            <i class="fas fa-download"></i> *.zip
                        </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div *ngIf="lastFirmwaresForBetaUsers">
        <h5>For beta users</h5>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Version(TXT)</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of lastFirmwaresForBetaUsers.firmwares">
                    <td scope="row">
                        {{ firmware.name }}
                    </td>
                    <td>
                        {{ firmware.versionTxt }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.fileName">
                            <i class="fas fa-download"></i> {{ firmware.fileName }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishDate : firmware.uploadDate) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'NEW'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'" [class.bg-light]="firmware.status == 'ARCHIVED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>
                        <a [href]="lastFirmwaresForBetaUsers.globalUrl" *ngIf="lastFirmwaresForBetaUsers.globalUrl">
                            <i class="fas fa-download"></i> *.zip
                        </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div *ngIf="lastFirmwaresForEndUsers">
        <h5>For end users</h5>
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Version(TXT)</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of lastFirmwaresForEndUsers.firmwares">
                    <td scope="row">
                        {{ firmware.name }}
                    </td>
                    <td>
                        {{ firmware.versionTxt }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.fileName">
                            <i class="fas fa-download"></i> {{ firmware.fileName }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishDate : firmware.uploadDate) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'NEW'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'" [class.bg-light]="firmware.status == 'ARCHIVED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                    </td>
                    <td>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td>
                        <a [href]="lastFirmwaresForEndUsers.globalUrl" *ngIf="lastFirmwaresForEndUsers.globalUrl">
                            <i class="fas fa-download"></i> *.zip
                        </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>
</div>
<div *ngIf="firmwares && firmwares.length > 0">
    <h4>Configure firmwares</h4>
    <div class="mb-3 background-hover" *ngIf="selectedFirmwareToEdit" [formGroup]="editFirmwareFormGroup">
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareNameInput">Name</label>
                    <input type="text" class="form-control" id="editFirmwareNameInput" placeholder="Apollo, Freescale, Nordic, Picture, TouchPanel, ..." formControlName="editFirmwareNameInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareFileInput">File</label>
                    <input type="text" class="form-control" id="editFirmwareFileInput" formControlName="editFirmwareFileInput">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareVersionTXTInput">Version(TXT)</label>
                    <input type="text" class="form-control" id="editFirmwareVersionTXTInput" placeholder="1.0, 2.1, 3.3, V004, ..." formControlName="editFirmwareVersionTXTInput">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareVersionInput">Version</label>
                    <input type="number" min="0" max="65535" class="form-control" id="editFirmwareVersionInput" formControlName="editFirmwareVersionInput" placeholder="101, 221, 345, ...">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareMinVersionInput">Min. Required (optional)</label>
                    <input type="number" min="0" max="65535" class="form-control" id="editFirmwareMinVersionInput" formControlName="editFirmwareMinVersionInput" placeholder="101, 221, 345, ...">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareMD5Input">Checksum</label>
                    <input type="text" class="form-control" id="editFirmwareMD5Input" placeholder="md5 (4cb1325f176091e7f0005fcc0e558c7d, ...)" formControlName="editFirmwareMD5Input">
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <label for="editFirmwareForceSelect">Update</label>
                    <select class="form-select" id="editFirmwareForceSelect" formControlName="editFirmwareForceSelect">
                        <option value="false">optional</option>
                        <option value="true">mandatory</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="mb-3 row gx-1">
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" [disabled]="editFirmwareFormGroup?.invalid" (click)="updateSelectedFirmwareToEdit()">
                    <i class="fas fa-save"></i> Save
                </button>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-secondary" (click)="cancelSelectedFirmwareToEdit()">
                    <i class="fas fa-ban"></i> Cancel
                </button>
            </div>
        </div>
    </div>
    <div *ngIf="!selectedFirmwareToEdit">
        <table class="table table-sm table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Version(TXT)</th>
                    <th scope="col">Version</th>
                    <th scope="col"><span class="text-muted">Min. Required</span></th>
                    <th scope="col">File</th>
                    <th scope="col">Date</th>
                    <th scope="col">Status</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let firmware of firmwares">
                    <td scope="row">
                        {{ firmware.name }}
                    </td>
                    <td>
                        {{ firmware.versionTxt }}
                    </td>
                    <td>
                        {{ firmware.version }}
                    </td>
                    <td>
                        <span class="text-muted">{{ firmware.minVersion ? firmware.minVersion : '-' }}</span>
                    </td>
                    <td>
                        <a [href]="firmware.url" [title]="firmware.fileName">
                            <i class="fas fa-download"></i> {{ firmware.fileName }}
                        </a>
                    </td>
                    <td>
                        <span class="text-muted">{{ (firmware.status == 'PUBLISHED' ? firmware.publishDate : firmware.uploadDate) | date: 'yyyy-MM-dd' : 'UTC' }}</span>
                    </td>
                    <td>
                        <span class="badge" [class.bg-secondary]="firmware.status == 'NEW'" [class.bg-warning]="firmware.status == 'TO_VALIDATE'" [class.bg-info]="firmware.status == 'VALIDATED'" [class.bg-success]="firmware.status == 'PUBLISHED'" [class.bg-light]="firmware.status == 'ARCHIVED'">
                            <small class="">
                                <strong>{{ firmware.status }}</strong>
                            </small>
                        </span>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-info" *ngIf="firmware.status == 'TO_VALIDATE'" (click)="validateFirmware(firmware.id)">
                            <i class="fas fa-check"></i> Validate
                        </a>
                        <a href="javascript:void(0)" class="text-success" *ngIf="firmware.status == 'VALIDATED'" (click)="publishFirmware(firmware.id)">
                            <i class="fas fa-share"></i> Publish
                        </a>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-primary" *ngIf="(firmware.status == 'NEW' || firmware.status == 'TO_VALIDATE') && firmware.uploader == user.id" (click)="displaySelectedFirmwareToEdit(firmware.id)">
                            <i class="fas fa-edit"></i> Edit
                        </a>
                    </td>
                    <td>
                        <a href="javascript:void(0)" class="text-danger" (click)="displayDeleteFirmware(firmware.id)" *ngIf="!deleteFirmwareVisibles[firmware.id]">
                            <i class="fas fa-trash-alt"></i> Delete
                        </a>
                        <a href="javascript:void(0)" class="text-danger" (click)="deleteFirmware(firmware.id)" *ngIf="deleteFirmwareVisibles[firmware.id]">
                            <i class="fas fa-exclamation-circle"></i> Confirm
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>